import { authorizedUser } from "components/Common/commonFunctions";
import * as API from "../API/index";

const createPublisher = async (bodyData) => {
  try {
    const res = await API.create_publisher(bodyData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

const updatePublisher = async (publisherId, bodyData) => {
  try {
    const res = await API.update_publisher(publisherId, bodyData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

const getPublisherDetailsById = async (publisherId) => {
  try {
    const res = await API.publisher_details(publisherId);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

const getPublisherList = async (
  pageNum,
  filters,
  searchString,
  sortField,
  sortOrder,
) => {
  try {
    const res = await API.publisher_list(
      pageNum,
      filters,
      searchString,
      sortField,
      sortOrder,
    );
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

const publisherResetPassword = async (publisherId) => {
  try {
    const res = await API.publisher_reset_password(publisherId);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

const createPublisherBillingInfo = async (billingData) => {
  try {
    const res = await API.create_publisher_billing_info(billingData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

const billingInfoByPublisherId = async (publisherId) => {
  try {
    const res = await API.billing_info_by_publisher_id(publisherId);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

const updateBillingInfoByPublisherId = async (publisherId, billingData) => {
  try {
    const res = await API.update_billing_info_by_publisher_id(
      publisherId,
      billingData,
    );
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export {
  createPublisher,
  updatePublisher,
  getPublisherDetailsById,
  getPublisherList,
  publisherResetPassword,
  billingInfoByPublisherId,
  updateBillingInfoByPublisherId,
  createPublisherBillingInfo,
};

export const advertiserBlockList = async (formData) => {
  try {
    const res = await API.advertiser_block_list(formData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const getAdvertiserBlockList = async (publisherID) => {
  try {
    const res = await API.get_advertiser_block_list(publisherID);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const downloadAdvertiserBlockList = async (publisherID) => {
  try {
    const res = await API.download_advertiser_block_list(publisherID);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const downloadAdsTxt = async (publisherID) => {
  try {
    const res = await API.download_ads_txt(publisherID);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const adsUploadFile = async (formData, publisherID) => {
  try {
    const res = await API.upload_ads_file(formData, publisherID);

    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const advertizeListUploadFile = async (formData, publisherID) => {
  try {
    const res = await API.upload_advertize_list_file(formData, publisherID);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const getAdsFile = async (formData, publisherID) => {
  try {
    const res = await API.get_ads_list(formData, publisherID);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const getAdvertizeListFile = async (formData, publisherID) => {
  try {
    const res = await API.get_advertize_list(formData, publisherID);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const downloadAdvertiseTxt = async (publisherID) => {
  try {
    const res = await API.download_advertiser_list(publisherID);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const getAdvertiserBlockListLogs = async (publisherID) => {
  try {
    const res = await API.get_advertise_logs_blocklist(publisherID);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const getAdvertiserLogsList = async (publisherID) => {
  try {
    const res = await API.get_advertise_logs_list(publisherID);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const getAdsLogsList = async (publisherID) => {
  try {
    const res = await API.get_ads_logs_list(publisherID);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const getPublisherReportingData = async (
  pageNum,
  filters,
  searchString,
  pageSize,
  viewType,
  sortField,
  sortOrder,
) => {
  try {
    const res = await API.get_publisher_reporting(
      pageNum,
      filters,
      searchString,
      pageSize,
      viewType,
      sortField,
      sortOrder,
    );
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const getPublisherKpiData = async (filters) => {
  try {
    const res = await API.get_publisher_kpi_api(filters);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const exportCsv = async (
  pageNum,
  filters,
  searchString,
  pageSize,
  viewType,
) => {
  try {
    const res = await API.export_csv(
      pageNum,
      filters,
      searchString,
      pageSize,
      viewType,
    );
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const bankDetailsHistoryList = async (publisherId, filterJson, pageNum) => {
  try {
    const res = await API.bank_detail_history_list(
      publisherId,filterJson, pageNum
    );
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const publisherBankDetailsList = async ( filterJson, pageNum) => {
  try {
    const res = await API.list_publisher_bank_details(
      filterJson, pageNum
    );
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const bankInfoDetails = async (ID) => {
  try {
    const res = await API.bank_info_details(
    ID
    );
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data); 
    return error?.response?.data || error;
  }
};

export const updateBillingInfoStatus = async (id, billingData) => {
  try {
    const res = await API.update_billing_info_status(
      id,
      billingData,
    );
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const publisherBillingStatus = async () => {
  try {
    const res = await API.publisher_billing_status();
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data); 
    return error?.response?.data || error;
  }
};

export const listPublisherForLedger = async (page, month, year, publisherId) => {
  try {
    const res = await API.publisher_ledger_list(page, month, year, publisherId);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data); 
    return error?.response?.data || error;
  }
};

export const listPublisherForPostedLedger = async (page, month, year, publisherId) => {
  try {
    const res = await API.posted_publisher_ledger_list(page, month, year, publisherId);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data); 
    return error?.response?.data || error;
  }
};